module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gP6Wn"))).then(() => parcelRequire('hEqeo'));